import { render, staticRenderFns } from "./TicketTags.vue?vue&type=template&id=23b82305&"
import script from "./TicketTags.vue?vue&type=script&lang=ts&"
export * from "./TicketTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports